// Allow observing the size of an element
//
// Example: x-size="console.log($width, $height)"

/**
 * @param {import('alpinejs')} Alpine
 */
export default Alpine => {
  Alpine.directive('size', (el, { expression }, { evaluate, evaluateLater, cleanup }) => {
    const rect = el.getBoundingClientRect()

    const size = Alpine.reactive({
      width: rect.width,
      height: rect.height,
    })

    Alpine.addScopeToNode(el, {
      get $width() {
        return size.width
      },
      get $height() {
        return size.height
      },
    })

    const runEffect = evaluateLater(expression)
    runEffect()
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        size.width = entry.borderBoxSize[0].inlineSize
        size.height = entry.borderBoxSize[0].blockSize
        runEffect()
      }
    })

    observer.observe(el)

    cleanup(() => {
      observer.disconnect()
    })
  })
}
